import { Datagrid, ListProps, TextField } from 'react-admin';
import { CustomList } from '../../components';

export default function UsersList(props: ListProps) {
  return (
    <CustomList {...props}>
      <Datagrid rowClick="edit">
        <TextField label="Nome" source="name" />

        <TextField label="E-mail" source="email" />
      </Datagrid>
    </CustomList>
  );
}
